module.exports = __webpack_public_path__ + "static/js/0.458896f8.chunk.worker.js"